// extracted by mini-css-extract-plugin
export default {"textInputLabel":"EQ-z","textInput":"FQ-z","error":"GQ-z","disabled":"HQ-z"};